import React from 'react';
import { TableBlock } from '@/types/ui-blocks';
import { TableWrapper } from '@strivelabs/ui-blocks';
import { useExportToGoogleSheets } from './use-export-to-google-sheets';

export interface TableBlockRendererProps {
  block: TableBlock;
}

/**
 * Renders a table block in the chat interface
 *
 * Passes all table configuration from the block content to the TableWrapper component,
 * which handles the table rendering and expand-to-dialog functionality.
 *
 * Adds an "Export to Google Sheets" entry to the export dropdown when the
 * user has a connected google_sheets credential. The hook handles the
 * credential gate internally — `exportOption` is `null` when no credential
 * exists, so the dropdown stays unchanged.
 */
export function TableBlockRenderer({ block: { content } }: TableBlockRendererProps) {
  const { exportOption: googleSheetsExportOption, dialog: googleSheetsExportDialog } = useExportToGoogleSheets(content.title);

  return (
    <>
      <TableWrapper
        headers={content.headers}
        rows={content.rows}
        title={content.title}
        description={content.description}
        variant={content.variant ?? 'default'}
        enableExport={content.enableExport ?? true}
        exportFilename={content.exportFilename ?? 'table-data'}
        extraExportOptions={googleSheetsExportOption ? [googleSheetsExportOption] : undefined}
        wrapperClassName={content.className}
        expandable={true}
        expandedMaxHeight="70vh"
        cellMaxWidth="240px"
      />
      {googleSheetsExportDialog}
    </>
  );
}
